import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getMissionAction } from '../../../../redux/screen/mission';
import { useNavigate } from 'react-router-dom'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import LimitPopup from './LimitPopup';
import LimitPopup2 from './LimitPopup2';
import Styles from '../style/trendingMission.module.scss'
import Play_btn from '../../../../assets/theme6/btn_image.svg'
import Fav from '../../../../assets/theme6/fav1.svg'
import Unfav from '../../../../assets/theme6/unfav.svg'
import { favoriteAction } from '../../../../redux/profile/favorite';
import { unfavoriteAction } from '../../../../redux/profile/unfavorite';
import { getUserDetailsAction } from '../../../../redux/user/getUserDetails';
import { getMissionDetailAction } from '../../../../redux/screen/missiondetails';
import AuthAxios from '../../../../config/authAxios';

function SubcategoryMission({ categoryId }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(5);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isMore, setIsMore] = useState(false);
  const getAppSelector = useSelector(state => state.getApp);
  const { data: { is_ads_enabled }, Config: { daily_user_attempt_limit } } = getAppSelector
  const userDetialsSelector = useSelector(state => state.getUserDetails)
  const { data: { daily_attempt_limit_count } } = userDetialsSelector
  const [showPopup, setShowPopup] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [isFav, setIsFav] = React.useState([])
  const [userScreenWidth, setUserScreenWidth] = useState(null)
  const [categoryid, setCategoryid] = useState("all");
  useEffect(() => {
    fetchUserDetails()
    setUserScreenWidth(window.innerWidth)

  }, [])

  const fetchUserDetails = async () => {
    const res = await dispatch(getUserDetailsAction())
    const data = res?.payload?.data?.favorites
    setIsFav([...data])
  }

  useEffect(() => {
    if (page != 0) {
      fetchData(0);
    }
  }, [page])
  console.log("categoryId====================>58", categoryId)

  useEffect(() => {
    if (categoryId != categoryid) {
      setPage(0)
      setCategoryid(categoryId);
    }
    fetchData(0);
  }, [categoryId]);


  const fetchData = async (e) => {
    try {
      setIsMore(false)
      setLoading(true)
      setOpen(true)

      let pageValue = e == 0 ? page : 0

      const res = await AuthAxios.get(`/users/api/reward/${categoryId}/${pageValue}/${limit}`)
      if (res?.data?.status === 200) {
        if (e == 0) {
          setData(prevData => [...prevData, ...res?.data?.data]);
        } else {
          setData([...res?.data?.data])
        }

        if (res.data?.data.length > 0) {
          if (res.data?.data.length < limit) {
            setIsMore(false);
          } else {
            setIsMore(true);
          }
        } else {
          setIsMore(false)
        }
        setLoading(false)
        setOpen(false)
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };


  function getTitle(email) {
    try {
      let deviceHeight = window.innerHeight
      if (email?.length <= 20) {
        return email
      } else {
        var fontSize = 8;
        if (deviceHeight == 768 && userScreenWidth == 393) {
          fontSize = 26
        }

        let remainScreenSize = userScreenWidth - 320;
        let charCanAdjust = Math.floor(remainScreenSize / fontSize);
        if (userScreenWidth <= 360) {
          if (email.length < email.substring(0, 12) + charCanAdjust) {
            return email.substring(0, 12 + charCanAdjust)
          }
          return email.substring(0, 12 + charCanAdjust - 3) + '...'
        } else {
          if (email.length < email.substring(0, 10) + charCanAdjust) {
            return email.substring(0, 10 + charCanAdjust)
          }
          return email.substring(0, 10 + charCanAdjust - 3) + '...'
        }
      }

    } catch (error) {
      console.log(error, "error")
    }


  }
  const favHandler = async (value) => {
    await AuthAxios.put(`/users/api/add-favorite-reward/mission`, { challenge_id: value })
    fetchData(1);
    setPage(0)
  }

  return (
    <>


        <div className={Styles.trending__heading}>
          <p className={Styles.heading_text2}>All Mission</p>
        </div>
        <div className={Styles.mission_sec}>

          {loading ? <Box sx={{ marginTop: "10px", width: "95%" }}>

            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
            <br />
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
            <br />
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />
            <br />
            <Skeleton style={{ borderRadius: "10px" }} animation="wave" variant="rectangular" width={"100%"} height={130} />


          </Box> : data?.length > 0 ? (data.map((item, index) => {

            return (
              <>
                <div className={Styles.continer} key={item?._id} >
                  <div key={"fav" + item?._id} onClick={() => { favHandler(item?._id) }} style={{ position: "absolute", top: "0px", right: "0px", zIndex: 999 }}>
                    {item?.favorite ? <img src={Fav} alt="fav" /> : <img src={Unfav} alt="fav2" />}

                  </div>
                  <div onClick={() => navigate(`/start-quiz/${item._id}`)} className={Styles.container1} key={item?._id}>
                    <div className={Styles.image_div}>
                      <img src={item?.image} alt="icon" />
                    </div>
                    <div className={Styles.item_container}  >
                      {/* <div className={Styles.Cash_bonanza_div}>{(userScreenWidth<380 && item?.title.length>14) ? item?.title.substring(0,14)+'...':item?.title.substring(0,18)}</div> */}
                      <div className={Styles.Cash_bonanza_div}>{getTitle(item?.challenge_name)}</div>
                      <div className={Styles.Fast_food_div}>{item?.category_name}</div>
                      <div className={Styles.fast_food_detail_container}>
                        <div className={Styles.food_detils} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><SmartDisplayOutlinedIcon style={{ color: "#fff", fontSize: "16px" }} /></div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;{item?.total_questions}</div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;Q</div>
                        </div>
                        |
                        <div className={Styles.food_detils} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><HourglassEmptyIcon style={{ color: "#fff", fontSize: "16px" }} /></div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;{item?.duration}</div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;mins</div>
                        </div>
                        |
                        <div className={Styles.food_detils} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}><PersonOutlineOutlinedIcon style={{ color: "#fff", fontSize: "18px" }} /></div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;&nbsp;{item?.total_attempted || 0}</div>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>&nbsp;</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button onClick={() => navigate(`/start-quiz/${item._id}`)} className={Styles.button_9}>
                    Get {item.reward.toFixed(2)} {item.currency_name}
                    <img className={Styles.btn_img} src={Play_btn} width={"60px"} height={"60px"} />
                  </button>

                </div>

                {index !== item.length - 1 && is_ads_enabled && <div className={Styles.continer}>
                  ads
                </div>}

              </>

            )
          })) : (
            <div className={Styles.ops_box}>Someone ate all the mission</div>)
          }

          {isMore &&
            <p className={Styles.view_more} onClick={() => setPage(page + 1)}>View More</p>
          }

          {showPopup && <LimitPopup open={showPopup} setOpen={setShowPopup} />}
          {open1 && (<LimitPopup2 open={open1} setOpen={setOpen1} />)}


        </div>
      


    </>
  )
}

export default SubcategoryMission;